module.exports = __webpack_public_path__ + "img/me.ad7afd12.svg";